// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x66Q","rootMobile":"styles_rootMobile__c-qwo"};